import React, { useContext, useMemo } from 'react';

import PageLoader from '../components/common/PageLoader';
import StickyPageHeader from '../components/common/StickyPageHeader';
import TerminalsServicedList from '../components/lists/TerminalsServicedList';
import { AuthContext } from '../contexts/authContext';
import {
  useCarrierTerminals,
  useSelectedCarrier,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierTerminalsPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { carrierId, selectedCarrier } = useSelectedCarrier();
  const { carrierTerminals, status } = useCarrierTerminals(carrierId);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const canView = !!selectedCarrier;
  const pageDataLoading = status === 'loading';

  const content =
    canView && (
      <>
        <StickyPageHeader
          subtitle={selectedCarrier.name}
          title="Terminals Serviced"
        />
        <TerminalsServicedList id="terminals" terminals={carrierTerminals} />
      </>
    );

  if (disableLayout) {
    return pageDataLoading ? <PageLoader /> : (content || null);
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier || pageDataLoading}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierTerminalsPage;
